import { Box, MenuItem } from "@mui/material";
import { useSuperAdminSublimacion } from "../../../context/SuperAdmin/SublimationContext";
import { useForm } from "react-hook-form";
import SelectInput from "./CustomItems";

const SublimSelectMenu = () => {
  const { dropdownOptions, selectedOpt, handleSelectOpt, tabValue } =
    useSuperAdminSublimacion();

  const { control } = useForm();

  return (
    <Box sx={{ display: "flex", gap: 2, marginTop: "30px" }}>
      {/* Primer Select: País u Organización */}
      <SelectInput
        control={control}
        name="id_org"
        label={`Seleccionar ${tabValue === 1 ? "país" : "organización"}`}
        selectedOpt={selectedOpt ?? ""}
        handleChange={handleSelectOpt}
      >
        {dropdownOptions.map((opt) => (
          <MenuItem key={opt.id} value={opt.id}>
            {opt.nombre}
          </MenuItem>
        ))}
      </SelectInput>
    </Box>
  );
};

export default SublimSelectMenu;
